<template>
    <pre class="tabs">
<b>Tuning: EADGBe (Standard Tuning)

/  slide up
\  slide down
h  hammer-on
p  pull-off
PM palm mute

Chords (Use bar chords):</b>

INTRO, VERSE, PRE-CHORUS
Bm7, E7, F#m7

END OF PRE-CHORUS
B7

CHORUS 1 AND CHORUS 2 AND CHORUS 3
DM7, C#m7, Cm7, Bm7, F#m7, E7
DM7, C#m7, Cm7, Bm7, A, E7, F#m7, E7, DM7

END OF CHORUS 1
C#m7

BRIDGE
DM7, C#m7, Cm7, Bm7, F#m7, E7


<b>TAB:</b>

INTRO
Variation 1

   PM PM PMPMPM  PM  PMPM PMPM PM PMPM  PM     PM PM
e|----------------------------------------------------------|
B|----7-----------9---------10h12---------------------------|
G|----7-----------7---------9h11--9h11----------------------|
D|----7-----------9---------------9h11--9-11p9--------------|
A|----9---5-6-7------8-9--9--------------------12-9---------|
E|-7--------------------------------------------------------|

Variation 2

   PM PM PMPMPM  PM  PMPM PMPM PM PMPM  PMPM PMPM PM PMPM
e|----------------------------------------------------------|
B|----7-----------9---------10h12---------------------------|
G|----7-----------7---------9h11--9h11-------9--------------|
D|----7-----------9---------------9h11--9-11---11-11-9-7----|
A|----9---5-6-7------8-9--9---------------------------------|
E|-7--------------------------------------------------------|

VERSE AND PRE-CHORUS
Variation 1

   PM PM PMPMPM  PM  PMPM PMPM PM PMPMPMPM PM     PMPM PM
e|---------------------------------------------------------------|
B|----7-----------9---------10h12--------------------------------|
G|----7-----------7---------9h11--9h11p9h11----------------------|
D|----7-----------9---------------9h11p9h11--9-11p9--------------|
A|----9---5-6-7------8-9--9-------------------------12-9---------|
E|-7-------------------------------------------------------------|

Variation 2

   PM PM PMPMPM  PM  PMPM PMPM PM PMPMPMPM  PM PMPM PM PM PMPM
e|---------------------------------------------------------------|
B|----7-----------9---------10h12--------------------------------|
G|----7-----------7---------9h11--9h11p9h11-------9--------------|
D|----7-----------9---------------9h11p9h11--9-11---11-11-9-7----|
A|----9---5-6-7------8-9--9--------------------------------------|
E|-7-------------------------------------------------------------|

PRE-CHORUS END
Variation 1

e|-------|
B|---7---|
G|---8---|
D|---7---|
A|---9---|
E|---7---|

CHORUS
Variation 1

e|------------------------------|
B|--7----5---5-4\3------10---9--|
G|--6----4---4-3\2------9----7--|
D|--7----6---6-5\4------11---9--|
A|--5----4---4-3\2----9----7----|
E|------------------------------|

Variation 2

e|------------------------------------|
B|--7----5----4\3----2---9-10---9--7--|
G|--6----4----3\2----2---7-9----7--6--|
D|--7----6----5\4----2---9-11---9--7--|
A|--5----4----3\2----0---7-9--8-7--5--|
E|------------------------------------|

CHORUS END
Variation 1

e|-----|
B|--5--|
G|--4--|
D|--6--|
A|--4--|
E|-----|

BRIDGE
Variation 1

e|------------------------------|
B|--7----5----3-------10---9----|
G|--6----4----2-------9----7----|
D|--7----6----4-------11---9----|
A|--5----4----2-----9----7------|
E|------------------------------|

<b>SEQUENCE:</b>

INTRO
Variataion 1, Variation 2

VERSE 1 AND VERSE 2
Variation 1, Variation 2 x2

PRE-CHORUS 1 AND PRE-CHORUS 2
Variation 1, Variation 2, Variation 1, End Variation 1

CHORUS 1
Variation 1, Variation 2, End Variation 1

CHORUS 2
Variation 1, Variation 2

BRIDGE
Variation 1

CHORUS 3
Variation 1, Variation 2 x4

Tab Written By: D. WATERMELONE
    </pre>
</template>
<script>
export default {
  name: "Honey"
};
</script>
